var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-plain-slider" },
    [
      _c(
        "swiper",
        {
          ref: "swiperRef",
          staticClass: "dynamic-carousel-container",
          attrs: {
            config: _vm.getDefaultConfig,
            pagination: true,
            navigation: true,
            "with-navigation-arrow": false,
          },
          scopedSlots: _vm._u([
            {
              key: "navigationprev",
              fn: function () {
                return [
                  _c("span", [
                    _vm._v(_vm._s(_vm.translation("swiper.previous"))),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "navigationnext",
              fn: function () {
                return [
                  _c("span", [_vm._v(_vm._s(_vm.translation("swiper.next")))]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        _vm._l(_vm.swiperSlides, function (slot, index) {
          return _c(
            "rb-dynamic-swiper-slide",
            { key: index, attrs: { index: index } },
            [_vm._t("default")],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }